
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.0001 5.82997L14.4601 8.28997C14.8501 8.67997 15.4801 8.67997 15.8701 8.28997C16.2601 7.89997 16.2601 7.26997 15.8701 6.87997L12.7001 3.69997C12.3101 3.30997 11.6801 3.30997 11.2901 3.69997L8.12014 6.87997C7.73014 7.26997 7.73014 7.89997 8.12014 8.28997C8.51014 8.67997 9.14014 8.67997 9.53014 8.28997L12.0001 5.82997ZM12.0001 18.17L9.54014 15.71C9.15014 15.32 8.52014 15.32 8.13014 15.71C7.74014 16.1 7.74014 16.73 8.13014 17.12L11.3001 20.3C11.6901 20.69 12.3201 20.69 12.7101 20.3L15.8801 17.13C16.2701 16.74 16.2701 16.11 15.8801 15.72C15.4901 15.33 14.8601 15.33 14.4701 15.72L12.0001 18.17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-unfold-more`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUnfoldMore

    ```js
    <b-new-b-icon-unfold-more />
    ```
</docs>


